import { z } from 'zod';

export const createModuleSchema = z.object({
  title: z.string().min(1, 'Title is required').max(255, 'Title must be less than 255 characters'),
  description: z.string().min(1, 'Description is required'),
  code: z.string().min(1, 'Code is required').max(100, 'Code must be less than 100 characters'),
  image_url: z.string().optional(),
  image: z.instanceof(File).optional(),
  is_active: z.preprocess((val) => val === 'true' || val === true, z.boolean()).default(true),
});

export type CreateModulePayload = z.infer<typeof createModuleSchema>;
